import type React from 'react';

/**
 * Opens the native date/time picker for an input element using the showPicker() API.
 *
 * Supports modern browsers (Chrome 99+, Edge 99+, Firefox 101+, Safari 16+).
 * Gracefully degrades to default behavior in older browsers.
 *
 * @param inputRef - React ref to the input element (HTMLInputElement)
 * @param disabled - Whether the input is disabled (picker won't open if true)
 * @returns void
 */
export const openInputPicker = (
  inputRef: React.RefObject<HTMLInputElement | null>,
  disabled?: boolean
): void => {
  if (disabled || !inputRef.current) return;

  try {
    // Use native showPicker() API to open the browser's date/time picker
    inputRef.current.showPicker();
  } catch (error) {
    // Graceful degradation for older browsers that don't support showPicker()
    // Falls back to default behavior (user must click the calendar icon)
  }
};
